import { useEffect, useState } from 'react';

/**
 * Minimales Hash-Routing (#/, #/admin, #/editor) — bewusst ohne
 * Router-Bibliothek; die Route ist damit teilbarer URL-Zustand.
 */
export function useHashRoute(): string {
  const [route, setRoute] = useState(() => window.location.hash.replace(/^#/, '') || '/');
  useEffect(() => {
    const onChange = (): void => setRoute(window.location.hash.replace(/^#/, '') || '/');
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
}

export function navigate(route: string): void {
  window.location.hash = route;
}
